import { NgModule } from '@angular/core';
import { DateUnifierPipe } from './custom-pipes/date-unifier/date-unifier.pipe';
import { TzDatePipe } from './custom-pipes/tz-date/tz-date.pipe';
import { UkTimezonePipe } from './custom-pipes/uk-timezone/uk-timezone.pipe';
import {CommonModule} from '@angular/common';

@NgModule({
  exports: [
    CommonModule,
    DateUnifierPipe,
    TzDatePipe,
    UkTimezonePipe,
  ],
  imports: [
    CommonModule,
    DateUnifierPipe,
    TzDatePipe,
    UkTimezonePipe,
  ],
  declarations: [
  ]
})
export class DatetimeModule {
  constructor() {
  }
}
